import { connect } from 'react-redux';
import Modal from './Modal';
import { 
  selectTripadvisorPreviewContent,
  selectTripadvisorIsPreviewLoading,
  selectTripadvisorPreviewError
} from '../redux/tripadvisorSlice';

const TripadvisorPreviewModal = ({ content, isLoading, error, isOpen, onClose }) => {
  return (
    <Modal 
      title="Content Preview (For Development Only)" 
      isOpen={isOpen} 
      onClose={onClose}
    >
      <div className="tripadvisor-preview-content">
        <p className="preview-description">
          This is a preview of the content that will be saved to the knowledge base.
          The following text will be processed and stored in the vector database:
        </p>
        
        {isLoading && (
          <div className="preview-loading" style={{ 
            textAlign: 'center',
            padding: '30px',
            fontSize: '16px',
            color: '#666'
          }}>
            <div className="loading-text">
              Loading content<span className="animated-ellipsis">...</span>
              <style jsx="true">{`
                .animated-ellipsis {
                  display: inline-block;
                  overflow: hidden;
                  vertical-align: bottom;
                  animation: ellipsis-animation 1.5s infinite;
                }
                
                @keyframes ellipsis-animation {
                  0% { width: 0; }
                  33% { width: 0.25em; }
                  66% { width: 0.5em; }
                  100% { width: 0.75em; }
                }
              `}</style>
            </div>
          </div>
        )}
        
        {error && (
          <div className="preview-error">
            <h4>Error loading preview content:</h4>
            <p>{error}</p>
          </div>
        )}
        
        {!isLoading && !error && content && (
          <pre 
            style={{ 
              whiteSpace: 'pre-wrap', 
              maxHeight: '500px', 
              overflowY: 'auto',
              padding: '15px',
              backgroundColor: '#f5f5f5',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '14px',
              lineHeight: '1.5'
            }}
          >
            {content}
          </pre>
        )}
        
        {!isLoading && !error && !content && (
          <div className="preview-empty">
            <p>No preview content available. Select a location and try again.</p>
          </div>
        )}
        
        <div className="preview-footer" style={{ marginTop: '20px', textAlign: 'right' }}>
          <button 
            onClick={onClose} 
            className="button primary"
            style={{ padding: '8px 16px' }}
          >
            Close Preview
          </button>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  content: selectTripadvisorPreviewContent(state),
  isLoading: selectTripadvisorIsPreviewLoading(state),
  error: selectTripadvisorPreviewError(state)
});

export default connect(mapStateToProps)(TripadvisorPreviewModal);